import firebase from 'firebase/app'
import 'firebase/storage'
import 'firebase/firestore'
import 'firebase/auth'
const firebaseConfig = {
    apiKey: "AIzaSyARCxMaHVIDyQg6pA1x6kPwkstnGTUTn5E",
    authDomain: "degram-app.firebaseapp.com",
    projectId: "degram-app",
    storageBucket: "degram-app.appspot.com",
    messagingSenderId: "1028124229484",
    appId: "1:1028124229484:web:b39fba7adf5d2b0e44fd49"
};
firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();
const storage = firebase.storage();
const auth = firebase.auth();
const timeStamp = firebase.firestore.FieldValue.serverTimestamp;

export { db, auth, storage, timeStamp }